import {
  OrganizationFeatureFlagsModel,
  OrganizationFeatureFlagsResponse,
} from 'src/models/organizations.models'
import { orgQueryKeys } from 'src/queries/queries.constants'
import {
  ExtendBaseQueryOptions,
  useExtendQuery,
} from 'src/queries/queries.utils'

interface OrganizationFeatureFlagsListModelOptions
  extends ExtendBaseQueryOptions<
    OrganizationFeatureFlagsResponse,
    OrganizationFeatureFlagsModel
  > {
  orgId: string | undefined
}

export const useQueryOrganizationFeatureFlags = ({
  orgId,
  enabled = true,
  ...rest
}: OrganizationFeatureFlagsListModelOptions) => {
  return useExtendQuery<
    OrganizationFeatureFlagsResponse,
    OrganizationFeatureFlagsModel
  >({
    queryKey: orgQueryKeys.featureFlags(orgId),
    queryUrl: () => `organizations/${orgId}/featureflags`,
    select: (data) => new OrganizationFeatureFlagsModel(data),
    // wait for orgId to be defined before making the request
    enabled: enabled && !!orgId,
    // what is an appropriate stale time for the org feature flags?
    staleTime: 1000 * 60,
    ...rest,
  })
}
